import request from "@/utils/request";


export function addStore(formData) {
    return request({
        url: '/wms/store/add',
        method: 'post',
        data: formData
    })
}

export function updateStore(formData) {
    return request({
        url: '/wms/store/update',
        method: 'post',
        data: formData
    })
}

/**
 * 仓库列表查询（分页接口）。
 * 注意：后端 /wms/store/list 的 startPage() 通过 ServletUtils.getParameter 读取分页参数，
 * 即只能从 URL query 读取——pageNum/pageSize 必须通过 params（axios 会拼到 URL 上）传入，
 * 放在 POST JSON body 里后端读不到，会导致翻页/改每页条数全部失效（列表永远停在第 1 页）。
 * @param formData 筛选条件（sName/sCode/sType 等），走 JSON body
 * @param params   分页参数 {pageNum, pageSize}，走 URL query
 */
export function queryStore(formData, params) {
    return request({
        url: '/wms/store/list',
        method: 'post',
        data: formData,
        params
    })
}

/**
 * 全量仓库列表（下拉专用）。
 * 背景：/wms/store/list 是分页接口，后端 startPage() 的分页参数默认 pageNum=1、pageSize=10，
 * 且只能从 URL query 读取（POST JSON body 传不进去）。queryStore 不带分页参数时会被
 * 静默截断到前 10 条——刚创建的仓库 s_id 较大、排在第 11 位以后，下拉里就永远看不到。
 * 这里在 URL 上显式携带大 pageSize 拉全量，供下拉/选择控件使用；
 * 仓库管理列表页等依赖分页表格的场景请继续使用 queryStore。
 */
export function queryStoreAll(formData) {
    return request({
        url: '/wms/store/list?pageNum=1&pageSize=9999',
        method: 'post',
        data: formData
    })
}
export function queryStoreInfo(formData) {
    return request({
        url: '/wms/store/query',
        method: 'post',
        data: formData
    })
}

export function storeType() {
    return request({
        url: '/config/sotre/type',
        method: 'get'
    })
}


export function storeState() {
    return request({
        url: '/config/sotre/states',
        method: 'get'
    })
}


export function addStorePart(formData) {
    return request({
        url: '/wms/storeset/add',
        method: 'post',
        data: formData
    })
}

export function updateStorePart(formData) {
    return request({
        url: '/wms/storeset/update',
        method: 'post',
        data: formData
    })
}

export function deleteStorePart(sId) {
    return request({
        url: '/wms/storeset/delete',
        method: 'post',
        data: [sId]
    })
}


//仓库配置的列表  比如分区列表  库位列表
export function queryPartType(formData, params) {
    return request({
        url: '/wms/storeset/list',
        method: 'post',
        data: formData,
        params
    })
}

/**
 * 库位/分区全量列表（不分页）。
 * 与 queryPartType 的区别仅在于走后端的 /wms/storeset/all —— 后者不调用 startPage()，
 * 因此不会被默认 pageSize=10 截断。下拉、选择弹窗等需要全量的场景统一用这个。
 */
export function queryPartTypeAll(formData) {
    return request({
        url: '/wms/storeset/all',
        method: 'post',
        data: formData,
    })
}

//查询单个数据信息
export function queryData(formData) {
    return request({
        url: '/wms/storeset/query',
        method: 'post',
        data: formData
    })
}

//库位批量导入
export function importStoreLocationByExcel(file) {
    const formData = new FormData();
    formData.append('file', file);
    return request({
        url: '/wms/storeset/import/excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

//下载库位导入模板
export function downloadStoreLocationTemplate() {
    window.open(`${process.env.VUE_APP_BASE_API}/wms/storeset/download/template`, '_blank');
}

export function generateInboundPdf(id, printStyle = 'inboundList', printSize = 'A4') {
    return request({
        url: '/inbound/generatePdf',
        method: 'get',
        params: { id, printStyle, printSize },
        timeout: 60000
    })
}


//分区类型
export function partitionType() {
    return request({
        url: '/config/sotre/partitiontype',
        method: 'get'
    })
}



